import { Paths } from '../../constants/paths';
export const buildCategoryUrl = item => {
  var _item$productTypes, _item$category;
  return `${Paths.SEARCH_RESULTS}?eco_PRODUCT_TYPE=${String(((_item$productTypes = item.productTypes) === null || _item$productTypes === void 0 ? void 0 : _item$productTypes[0]) || 'APP')}&eco_CATEGORY=${encodeURIComponent((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category[0])}`;
};
export const buildCollectionUrl = item => {
  return Paths.FEATURED_COLLECTION.replace(':collectionSlug', item.slug || '');
};
export const buildListingUrl = slug => {
  return Paths.LISTING_DETAILS.replace(':listingSlug', slug);
};
export const buildSearchUrl = (input, queryType = '') => {
  const query = typeof input === 'string' ? input : input.term;
  const queryTypeValue = typeof input === 'string' ? queryType : String(input.queryType || 'ELASTIC_SEARCH');
  const searchParams = new URLSearchParams();
  searchParams.set('eco_search', query);
  if (queryTypeValue) {
    searchParams.set('eco_queryType', queryTypeValue);
  }
  const queryString = searchParams.toString().replace(/\+/g, '%20');
  return `${Paths.SEARCH_RESULTS}?${queryString}`;
};
export const navigateToSearchResults = (item, history) => {
  var _item$slug;
  switch (item.resultType) {
    case 'QUERY':
      history.push(buildSearchUrl(item));
      break;
    case 'LISTING':
      history.push(buildListingUrl((_item$slug = item.slug) !== null && _item$slug !== void 0 ? _item$slug : ''));
      break;
    case 'CATEGORY':
      history.push(buildCategoryUrl(item));
      break;
    case 'COLLECTION':
      history.push(buildCollectionUrl(item));
      break;
    default:
      break;
  }
};